import RoomSelectView from "./RoomSelectView";
import C_PointerEvt from "../core/const/C_PointerEvt";


class RoomSelectViewPortrait extends RoomSelectView
{
    constructor()
    {
        super();
    }


    create()
    {
        this.addBackground();
        this.addPlatform();
        this.addRooms();
        this.addLogo();
        this.addButtons();
    }


    addBackground()
    {
        this.bg = this.assets.getSprite("lobbyBg", '.jpg');
        super.addBackground();
    }


    addLogo()
    {
        this.logo = this.assets.getSprite("logo");
        this.layout.propHeightScale(this.logo, 20);
        this.layout.horizontalAlignCenter(this.logo);
        this.layout.verticalAlignTop(this.logo, 5);
        this.addChild(this.logo);
    }


    addBalanceInfo() {}


    addPlatform()
    {
        this.platformMid = this.assets.getSprite("lobby_ships_platform");
        this.layout.propHeightScale(this.platformMid, 100);
        this.layout.verticalAlignMiddle(this.platformMid);
        this.layout.horizontalAlignCenter(this.platformMid);
        this.addChild(this.platformMid);
    }


    addRooms()
    {
        this.middleContainer = new PIXI.Container();
        this.addChild(this.middleContainer);

        this.chosenShipId = 0;

        this.addHolograms();
        this.addRoomShips();
        this.setEllipseVariables();

        // this.middleContainer.children.sort(this.sortChildren.bind(this));

        this.switchShipTextures();
        this.updateRooms();
    }


    addHolograms()
    {
        this.hologramTextures = [];
        for (let i = 1; i <= 3; i++)
        {
            let texture = this.assets.getTexture("hologram_room_" + i);
            this.hologramTextures.push(texture);
        }

        this.hologramContainer = new PIXI.Container();
        this.middleContainer.addChild(this.hologramContainer);

        this.hologram = new PIXI.Sprite(this.hologramTextures[this.chosenShipId]);
        this.layout.propHeightScale(this.hologram, 100);
        this.layout.verticalAlignMiddle(this.hologram);
        this.layout.horizontalAlignCenter(this.hologram);
        this.hologramContainer.addChild(this.hologram);

        this.hologramLight = this.assets.getSprite("hologram_light");
        this.layout.propHeightScale(this.hologramLight, 100);
        this.layout.verticalAlignMiddle(this.hologramLight);
        this.layout.horizontalAlignCenter(this.hologramLight);
        this.hologramContainer.addChild(this.hologramLight);

        this.hologramContainer.extraY = true;
    }


    addRoomShips()
    {
        this.canChoose = true;
        this.swiped = false;
        let anchorX = 0.43;
        let anchorY = 1;

        this.nonChosenTextures = [
            {
                ship: this.assets.getTexture("lobby_ship_1")
            },
            {
                ship: this.assets.getTexture("lobby_ship_2")
            },
            {
                ship: this.assets.getTexture("lobby_ship_3"),
                plate: this.assets.getTexture("lobby_ship_3_plate")
            }];
        // this.chosenTextures = [
        //     {
        //         ship: this.assets.getTexture("lobby_ship_1_glow")
        //     },
        //     {
        //         ship: this.assets.getTexture("lobby_ship_2_glow")
        //     },
        //     {
        //         ship: this.assets.getTexture("lobby_ship_3_glow"),
        //         plate: this.assets.getTexture("lobby_ship_3_plate_glow"),
        //     }];

        this.ships = []; // the parent container/sprite is added here
        this.shipsSprites = [];
        this.platesSprites = []; // the plates, used for texture swapping
        this.doorsHD = []; // the doors to be made visible after door animation is over
        this.zoomAnims = [];
        this.zoomEndPos = [
            new PIXI.Point(.527, .795),
            new PIXI.Point(.512, .81), // new PIXI.Point(.512, .83),
            new PIXI.Point(.53, .82)];
        // this.zoomEndScale = [50, 20, 25];
        this.zoomEndScale = [12, 12, 12];

        this.addRoom1(anchorX, anchorY);
        this.addRoom2(anchorX, anchorY);
        this.addRoom3(anchorX, anchorY);


        this.interactive = true;
        this.on(C_PointerEvt.DOWN, this.onPointerDown, this);
        this.on(C_PointerEvt.UP, this.onPointerUp, this);

        this.chosenShip = this.room1ship;
    }


    addRoom1(anchorX, anchorY)
    {
        this.platesSprites.push(null); // no plate

        this.room1ship = this.assets.getSprite("lobby_ship_1");
        this.room1ship.anchor.set(anchorX, anchorY);
        this.middleContainer.addChild(this.room1ship);
        this.room1ship.roomId = 0;
        this.ships.push(this.room1ship);
        this.shipsSprites.push(this.room1ship);

        let room1AnimTex = this.assets.generateFrames("ship1_zoomAnim_", 1, 0, 7);
        this.room1doorAnim = new PIXI.extras.AnimatedSprite(room1AnimTex);
        this.room1doorAnim.width = this.room1ship.width;
        this.room1doorAnim.height = this.room1ship.height;
        this.room1doorAnim.anchor.set(anchorX, anchorY);
        this.room1doorAnim.alpha = 0;
        this.room1doorAnim.loop = false;
        this.room1doorAnim.animationSpeed = 0.3;
        this.room1ship.addChild(this.room1doorAnim);
        this.zoomAnims.push(this.room1doorAnim);

        this.room1DoorHD = this.assets.getSprite("ship1_zoomAnim_endFrameBig");
        this.room1DoorHD.width = this.room1ship.width;
        this.room1DoorHD.height = this.room1ship.height;
        this.room1DoorHD.anchor.set(anchorX, anchorY);
        this.room1ship.addChild(this.room1DoorHD);
        this.room1DoorHD.alpha = 0;
        this.doorsHD.push(this.room1DoorHD);


        this.getInteractionTarget(anchorX, anchorY, this.room1ship);
    }


    addRoom2(anchorX, anchorY)
    {
        this.platesSprites.push(null); // no plate

        this.room2ship = this.assets.getSprite("lobby_ship_2");
        this.room2ship.anchor.set(anchorX, anchorY);
        this.middleContainer.addChild(this.room2ship);
        this.room2ship.roomId = 1;
        this.ships.push(this.room2ship);
        this.shipsSprites.push(this.room2ship);

        let room2AnimTex = this.assets.generateFrames("ship2_zoomAnim_", 1, 0, 7);
        this.room2doorAnim = new PIXI.extras.AnimatedSprite(room2AnimTex);
        this.room2doorAnim.width = this.room2ship.width;
        this.room2doorAnim.height = this.room2ship.height;
        this.room2doorAnim.anchor.set(anchorX, anchorY);
        this.room2doorAnim.alpha = 0;
        this.room2doorAnim.loop = false;
        this.room2doorAnim.animationSpeed = 0.3;
        this.room2ship.addChild(this.room2doorAnim);
        this.zoomAnims.push(this.room2doorAnim);

        this.room2DoorHD = this.assets.getSprite("ship2_zoomAnim_endFrameBig");
        this.room2DoorHD.width = this.room2ship.width;
        this.room2DoorHD.height = this.room2ship.height;
        this.room2DoorHD.anchor.set(anchorX, anchorY);
        this.room2ship.addChild(this.room2DoorHD);
        this.room2DoorHD.alpha = 0;
        this.doorsHD.push(this.room2DoorHD);

        this.getInteractionTarget(anchorX, anchorY, this.room2ship);
    }


    addRoom3(anchorX, anchorY)
    {
        this.room3plate = this.assets.getSprite("lobby_ship_3_plate");
        this.room3plate.anchor.set(anchorX, anchorY);
        this.middleContainer.addChild(this.room3plate);
        this.room3plate.roomId = 2;
        this.ships.push(this.room3plate);
        this.platesSprites.push(this.room3plate);

        let room3AnimTex = this.assets.generateFrames("ship3_zoomAnim_", 1, 0, 4);
        this.room3doorAnim = new PIXI.extras.AnimatedSprite(room3AnimTex);
        this.room3doorAnim.width = this.room3plate.width;
        this.room3doorAnim.height = this.room3plate.height;
        this.room3doorAnim.anchor.set(anchorX, anchorY);
        this.room3doorAnim.alpha = 0;
        this.room3doorAnim.loop = false;
        this.room3doorAnim.animationSpeed = 0.3;
        this.room3plate.addChild(this.room3doorAnim);
        this.zoomAnims.push(this.room3doorAnim);

        this.room3DoorHD = this.assets.getSprite("ship3_zoomAnim_endFrameBig");
        this.room3DoorHD.width = this.room3plate.width;
        this.room3DoorHD.height = this.room3plate.height;
        this.room3DoorHD.anchor.set(anchorX, anchorY);
        this.room3plate.addChild(this.room3DoorHD);
        this.room3DoorHD.alpha = 0;
        this.doorsHD.push(this.room3DoorHD);

        this.room3ship = this.assets.getSprite("lobby_ship_3");
        this.room3ship.anchor.set(anchorX, anchorY);
        this.room3plate.addChild(this.room3ship);
        this.shipsSprites.push(this.room3ship);

        this.room3lights = this.assets.getSprite("lobby_ship_3_lights");
        this.room3lights.anchor.set(anchorX, anchorY);
        this.room3plate.addChild(this.room3lights);

        this.getInteractionTarget(anchorX, anchorY, this.room3plate);
    }


    getInteractionTarget(anchorX, anchorY, parent)
    {
        let clickCircle = this.assets.getSprite("target_red");
        this.layout.propHeightScale(clickCircle, 100, parent);
        clickCircle.anchor.set(anchorX, anchorY);
        parent.addChild(clickCircle);
        clickCircle.alpha = 0;
        clickCircle.interactive = true;
        clickCircle.on(C_PointerEvt.TAP, this.onTap, this);
    }


    setEllipseVariables()
    {
        // this.minHeight = 10;
        // this.maxHeight = 20;

        this.maxHeight = [16, 20.5, 28];
        this.minHeight = [this.maxHeight[0]*.6, this.maxHeight[1]*.6, this.maxHeight[2]*.6]; // 60% of max

        this.ellipseAngle = {angle: 0};
        // TODO set different start angle depending on last chosen ship
        // this.roomAngles = [Math.PI/2, Math.PI/2 - Math.PI * (2/3), Math.PI/2 + Math.PI * (2/3)]; // start angles
        // this.ellipseRadX = this.layout.relWidth(30);
        // this.ellipseRadY = this.layout.relHeight(9); // Total Y dif - 20, from 70 to 90
        // this.circleCenter = new PIXI.Point(this.layout.relWidth(50), this.layout.relHeight(80));
        // this.minEllipseY = this.circleCenter.y - this.ellipseRadY;
        // this.deltaAngle = Math.PI*2 / this.model.getRoomData().length; // for 3 rooms its 120 degrees

        this.roomAngles = [Math.PI/2, Math.PI/2 - Math.PI * (2/3), Math.PI/2 + Math.PI * (2/3)]; // start angles
        this.ellipseRadX = this.layout.relWidth(30);
        this.ellipseRadY = this.layout.relHeight(9); // Total Y dif - 20, from 70 to 90
        this.circleCenter = new PIXI.Point(this.layout.relWidth(48), this.layout.relHeight(80));
        this.minEllipseY = this.circleCenter.y - this.ellipseRadY;
        this.deltaAngle = Math.PI*2 / this.model.getRoomData().length; // for 3 rooms its 120 degrees
    }


    sortChildren(child1, child2)
    {
        let child1Y = child1.y;
        let child2Y = child2.y;

        if (child1.extraY)
        {
            child1Y = child1.y + this.circleCenter.y; // circle center
        }
        else if (child2.extraY)
        {
            child2Y = child2.y + this.circleCenter.y;
        }

        return (child1Y > child2Y) ? 1 : -1;
    }


    onTap(e)
    {
        let endSwipeX = e.data.getLocalPosition(this).x;
        let deltaSwipeX = endSwipeX - this.startSwipeX;
        if (deltaSwipeX > this.layout.relWidth(2) || deltaSwipeX < -this.layout.relWidth(2))
        {
            return;
        }

        if (e.target && this.canChoose && !this.swiped)
        {
            let ship = e.target.parent;
            if (ship == this.chosenShip)
            {
                this.onNavigate(ship.roomId);
            }
            else
            {
                let clockwise = ship.x > this.chosenShip.x;
                this.chosenShip = ship;
                this.chosenShipId = ship.roomId;
                this.changeRoom(clockwise);
            }
        }
    }


    onPointerDown(e)
    {
        this.startSwipeX = e.data.getLocalPosition(this).x;
    }


    onPointerUp(e)
    {
        if (e.target == this.soundButton || e.target == this.paytableButton)
        {
            return;
        }
        this.endSwipeX = e.data.getLocalPosition(this).x;
        let deltaSwipeX = this.endSwipeX - this.startSwipeX;
        if (deltaSwipeX > this.layout.relWidth(2))
        {
            if (this.canChoose)
            {
                this.swiped = true;
                let newId = this.getSwipeShipId(-1);
                this.chosenShip = this.ships[newId];
                this.chosenShipId = newId;
                this.changeRoom(false);
                e.stopPropagation();
            }
        }
        else if (deltaSwipeX < -this.layout.relWidth(2))
        {
            if (this.canChoose)
            {
                this.swiped = true;
                let newId = this.getSwipeShipId(1);
                this.chosenShip = this.ships[newId];
                this.chosenShipId = newId;
                this.changeRoom(true);
                e.stopPropagation();
            }
        }
    }


    getSwipeShipId(index)
    {
        let newIndex = this.chosenShipId + index;
        if (newIndex > 2) newIndex = 0;
        else if (newIndex < 0) newIndex = 2;

        return newIndex;
    }


    changeRoom(clockwise)
    {
        this.canChoose = false;
        this.hologram.texture = this.hologramTextures[this.chosenShipId];
        this.switchShipTextures();
        clockwise == true ? this.tweenClockwise() : this.tweenAnticlockwise();
    }


    switchShipTextures()
    {
        return;
        for (let i = 0; i < this.ships.length; i++)
        {
            let ship = this.ships[i];
            let shipSprite = this.shipsSprites[i];
            let plateSprite = this.platesSprites[i];
            if (ship == this.chosenShip)
            {
                if (this.chosenTextures[i].ship)
                {
                    shipSprite.texture = this.chosenTextures[i].ship;
                }
                if (this.chosenTextures[i].plate)
                {
                    plateSprite.texture = this.chosenTextures[i].plate;
                }
            }
            else
            {
                if (this.nonChosenTextures[i].ship)
                {
                    shipSprite.texture = this.nonChosenTextures[i].ship;
                }
                if (this.nonChosenTextures[i].plate)
                {
                    plateSprite.texture = this.nonChosenTextures[i].plate;
                }
            }
        }
    }


    tweenClockwise()
    {
        let targetAngle = this.ellipseAngle.angle + this.deltaAngle;
        TweenMax.to(this.ellipseAngle, 1, {angle: targetAngle, onUpdate: this.updateRooms, onUpdateScope: this})
        TweenMax.delayedCall(1, this.onCircleMovementFinish, [], this);
    }


    tweenAnticlockwise()
    {
        let targetAngle = this.ellipseAngle.angle - this.deltaAngle;
        TweenMax.to(this.ellipseAngle, 1, {angle: targetAngle, onUpdate: this.updateRooms, onUpdateScope: this})
        TweenMax.delayedCall(1, this.onCircleMovementFinish, [], this);
    }


    onCircleMovementFinish()
    {
        this.canChoose = true;
        this.swiped = false;
    }


    updateRooms()
    {
        for (let i = 0; i < this.ships.length; i++)
        {
            let ship = this.ships[i];

            ship.x = this.ellipseRadX*Math.cos(this.roomAngles[i] + this.ellipseAngle.angle) + this.circleCenter.x;
            ship.y = this.ellipseRadY*Math.sin(this.roomAngles[i] + this.ellipseAngle.angle) + this.circleCenter.y;



            let yDif = this.ellipseRadY*2;
            let size = this.minHeight[i] + (this.maxHeight[i] - this.minHeight[i]) *
                (ship.y - this.minEllipseY)/yDif;

            this.layout.propHeightScale(ship, size);
        }

        this.middleContainer.children.sort(this.sortChildren.bind(this));
    }


    onNavigate(roomId)
    {
        this.canChoose = false;
        this.zoomShip(this.zoomEndPos[roomId], this.zoomEndScale[roomId]);
        this.addFadeOut(this.zoomEndPos[roomId]);
        TweenMax.delayedCall(0, this.playRoomEnterAnim, [this.zoomAnims[roomId], this.doorsHD[roomId]], this);
        TweenMax.delayedCall(1.5, this.controller.selectRoom, [roomId], this.controller);
    }


    playRoomEnterAnim(anim, hdDoor)
    {
        anim.onComplete = () => {hdDoor.alpha = 1; anim.alpha = 0;};
        anim.alpha = 1;
        anim.gotoAndPlay(0);
    }


    addFadeOut(pos)
    {
        let overlay = this.assets.getSprite("zoom_light");
        overlay.anchor.set(0.5, 0.5);
        this.layout.propHeightScale(overlay, 20);
        overlay.x = this.bg.width*pos.x;
        overlay.y = this.bg.height*pos.y;
        this.addChild(overlay);

        // TweenMax.from(overlay, 1.1, {alpha: 0, delay: 0.3, ease:Power2.easeOut});
        // TweenMax.from(overlay.scale, 1.1, {x: 0, y: 0, delay: 0.3, ease:Power2.easeOut});

        TweenMax.from(overlay, 1, {alpha: 0, delay: 0.3, ease:Power1.easeOut});
        TweenMax.from(overlay.scale, 1, {x: 0, y: 0, delay: 0.3, ease:Power1.easeInOut});
    }


    // addFadeOut(pos)
    // {
    //     // let overlay = this.app.nav.addOverlay(pos, 0x000000, 200, 200);
    //
    //
    //     let overlay = new PIXI.Graphics();
    //     // overlay.beginFill(0x000000);
    //     overlay.beginFill(0xffffff);
    //     overlay.drawRect(0, 0, this.bg.width, this.bg.height);
    //     this.addChild(overlay);
    //
    //     // overlay.pivot.x = overlay.width*.5;
    //     // overlay.pivot.y = overlay.height*.5;
    //     //
    //     // overlay.x = this.bg.width*pos.x;
    //     // overlay.y = this.bg.height*pos.y;
    //
    //     TweenMax.from(overlay, 0.8, {alpha: 0, delay: 0.2, ease:Power2.easeIn});
    //     // TweenMax.from(overlay.scale, 1, {x: 0, y: 0, delay: 0.75, ease:Power2.easeIn});
    // }


    zoomShip(shipPos, scaleFactor)
    {
        // let shipPos = new PIXI.Point(.5, .8);
        // let scaleFactor = 100;

        let w = this.bg.width;
        let h = this.bg.height;

        let dX = (.5 - shipPos.x) * w;
        let dY = (.5 - shipPos.y) * h;

        let x = this.x - (scaleFactor-1) * .5 * w + dX * scaleFactor;
        let y = this.x - (scaleFactor-1) * .5 * h + dY * scaleFactor;

        // TweenMax.to(this.scale, 2, {x:scaleFactor, y:scaleFactor, ease:Cubic.easeInOut});
        // TweenMax.to(this, 2, {x:x, y:y, ease:Cubic.easeInOut});
        // TweenMax.to(this.scale, 1.5, {x:scaleFactor, y:scaleFactor, ease:Cubic.easeIn});
        // TweenMax.to(this, 1.5, {x:x, y:y, ease:Cubic.easeIn});
        TweenMax.to(this.scale, 1, {x:scaleFactor, y:scaleFactor, delay: 0.2, ease:Power2.easeInOut});
        TweenMax.to(this, 1, {x:x, y:y, delay: 0.2, ease:Power2.easeInOut});
    }


}

export default RoomSelectViewPortrait;